const emailEntityData = {
  type: 'string',
  acl: { read: true, write: true },
  validate: {
    rules: 'required,isEmail',
    messages: { required: 'email_required', isEmail: 'email_invalid' },
  },
};

let entityMetaStatic = {
  'Pass:Pass': {
    name: 'Pass:Pass',
    data: {
      password: {
        name: 'password',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required,isLength:8:30',
          messages: {
            required: 'password_required',
            isLength: 'password_length',
          },
        },
      },
      repeatPassword: {
        name: 'repeatPassword',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required,isLength:8:30',
          messages: {
            required: 'repeat_password_required',
            isLength: 'repeat_password_length',
          },
        },
      },
    },
  },
  'Checkout:UserData': {
    name: 'Checkout:UserData',
    data: {
      salutation: {
        name: 'salutation',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required',
          messages: { required: 'salutation_required' },
        },
      },
      gender: {
        name: 'gender',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required',
          messages: { required: 'gender_required' },
        },
      },
      firstName: {
        name: 'firstName',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required,isLength:2:50',
          messages: {
            required: 'first_name_required',
            isLength: 'first_name_required',
          },
        },
      },
      lastName: {
        name: 'lastName',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required,isLength:2:50',
          messages: {
            required: 'last_name_required',
            isLength: 'last_name_required',
          },
        },
      },
      street: {
        name: 'street',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required,isLength:2:50',
          messages: { required: 'street_required', isLength: 'street_required' },
        },
      },
      houseNumber: {
        name: 'houseNumber',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required,isLength:1:20',
          messages: {
            required: 'house_number_required',
            isLength: 'house_number_required',
          },
        },
      },
      apartmentNumber: {
        name: 'apartmentNumber',
        type: 'string',
        acl: { read: true, write: true },
        validate: { rules: '', messages: {} },
      },
      zipCode: {
        name: 'zipCode',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required,isLength:4:8',
          messages: {
            required: 'zip_code_required',
            isLength: 'zip_code_invalid',
          },
        },
      },
      city: {
        name: 'city',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required,isLength:3:50',
          messages: { required: 'city_required', isLength: 'city_required' },
        },
      },
      country: {
        name: 'country',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required,isLength:2:2',
          messages: {
            required: 'country_required',
            isLength: 'country_required',
          },
        },
      },
      mobile: {
        name: 'mobile',
        type: 'string',
        acl: { read: true, write: true },
        validate: { rules: '', messages: {} },
      },
    },
  },
};

// lead form (cms)
entityMetaStatic = {
  ...entityMetaStatic,
  'Cms:LeadForm': {
    name: 'Cms:LeadForm',
    data: {
      phone: {
        name: 'phone',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required',
          messages: { required: 'phone_required' },
        },
      },
      email: { name: 'email', ...emailEntityData },
      ...entityMetaStatic['Checkout:UserData'].data,
    },
  },
};
// delete the country parameter
delete entityMetaStatic['Cms:LeadForm'].data.country;

entityMetaStatic = {
  ...entityMetaStatic,
  'Checkout:UserDataWithRegistration': {
    name: 'Checkout:UserDataWithRegistration',
    data: {
      email: { name: 'email', ...emailEntityData },
      ...entityMetaStatic['Pass:Pass'].data,
      ...entityMetaStatic['Checkout:UserData'].data,
    },
  },
};

entityMetaStatic = {
  ...entityMetaStatic,
  'Checkout:CompanyData': {
    name: 'Checkout:CompanyData',
    data: {
      ...entityMetaStatic['Checkout:UserData'].data,
      company: {
        name: 'company',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required',
          messages: { required: 'company_required' },
        },
      },
    },
  },
};

entityMetaStatic = {
  ...entityMetaStatic,
  'Checkout:CompanyDataWithRegistration': {
    name: 'Checkout:CompanyDataWithRegistration',
    data: {
      email: { name: 'email', ...emailEntityData },
      ...entityMetaStatic['Pass:Pass'].data,
      ...entityMetaStatic['Checkout:UserData'].data,
      company: {
        name: 'company',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required',
          messages: { required: 'company_required' },
        },
      },
      legalAccepted: {
        name: 'legalAccepted',
        type: 'boolean',
        acl: { read: true, write: true },
        validate: {
          rules: 'required,isChecked',
          messages: { isChecked: 'accept_terms_before_continuing' },
        },
      },
    },
  },
};

// newsletter form (cms)
entityMetaStatic = {
  ...entityMetaStatic,
  'Cms:NewsletterForm': {
    name: 'Cms:NewsletterForm',
    data: {
      email: { name: 'email', ...emailEntityData },
    },
  },
};

// login form (cms)
entityMetaStatic = {
  ...entityMetaStatic,
  'Cms:LoginForm': {
    name: 'Cms:LoginForm',
    data: {
      username: {
        name: 'username',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required,isLength:2:50',
          messages: {
            required: 'username_required',
            isLength: 'username_required',
          },
        },
      },
      password: {
        name: 'password',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required,isLength:8:30',
          messages: {
            required: 'password_required',
            isLength: 'password_length',
          },
        },
      },
    },
  },
};

// signup form (cms)
entityMetaStatic = {
  ...entityMetaStatic,
  'Cms:SignupForm': {
    name: 'Cms:SignupForm',
    data: {
      company: {
        name: 'company',
        type: 'string',
        acl: { read: true, write: true },
        validate: { rules: '', messages: {} },
      },
      email: { name: 'email', ...emailEntityData },
      mobile: {
        name: 'mobile',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required,isLength:8:30',
          messages: {
            required: 'This value should not be blank.',
            isLength: 'This value should not be blank.',
          },
        },
      },
      ...entityMetaStatic['Checkout:UserData'].data,
      ...entityMetaStatic['Pass:Pass'].data,
      legalAccepted: {
        name: 'legalAccepted',
        type: 'boolean',
        acl: { read: true, write: true },
        validate: {
          rules: 'required,isChecked',
          messages: { isChecked: 'accept_terms_before_continuing' },
        },
      },
    },
  },
};

// company signup form (chedri)
entityMetaStatic = {
  ...entityMetaStatic,
  'Chedri:CompanySignupForm': {
    name: 'Chedri:CompanySignupForm',
    data: {
      ...entityMetaStatic['Cms:SignupForm'].data,
      company: {
        name: 'company',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required',
          messages: { required: 'company_required' },
        },
      },
      companyEmail: { name: 'companyEmail', ...emailEntityData },
      testDomain: {
        name: 'testDomain',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required',
          messages: { required: 'test_domain_required' },
        },
      },
      liveDomain: {
        name: 'liveDomain',
        type: 'string',
        acl: { read: true, write: true },
        validate: { rules: '', messages: {} },
      },
    },
  },
};

// contact form (cms)
entityMetaStatic = {
  ...entityMetaStatic,
  'Cms:ContactForm': {
    name: 'Cms:ContactForm',
    data: {
      email: { name: 'email', ...emailEntityData },
      name: {
        name: 'name',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required,isLength:2:50',
          messages: { required: 'name_required', isLength: 'name_required' },
        },
      },
      content: {
        name: 'content',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required,isLength:2:5000',
          messages: {
            required: 'message_required',
            isLength: 'message_required',
          },
        },
      },
    },
  },
};

// more information about cash payment (for cars)
entityMetaStatic = {
  ...entityMetaStatic,
  'Checkout:PaymentCashAdditionalInfos': {
    name: 'Checkout:PaymentCashAdditionalInfos',
    data: {
      placeOfBirth: {
        name: 'placeOfBirth',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required,isLength:2:50',
          messages: {
            required: 'place_of_birth_required',
            isLength: 'place_of_birth_required',
          },
        },
      },
      dateOfBirth: {
        name: 'dateOfBirth',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required,isLength:2:5000',
          messages: {
            required: 'date_of_birth_required',
            isLength: 'date_of_birth_required',
          },
        },
      },
      nationality: {
        name: 'nationality',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required,isLength:2:5000',
          messages: {
            required: 'nationality_required',
            isLength: 'nationality_required',
          },
        },
      },
    },
  },
};

entityMetaStatic = {
  ...entityMetaStatic,
  'Financial:BankData': {
    name: 'Financial:BankData',
    data: {
      accountHolder: {
        name: 'accountHolder',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required,isLength:2:5000',
          messages: {
            required: 'account_holder_required',
            isLength: 'account_holder_required',
          },
        },
      },
      iban: {
        name: 'iban',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required,isIban',
          messages: {
            required: 'iban_required',
            isIban: 'iban_has_wrong_format',
          },
        },
      },
      swiftBic: {
        name: 'swiftBic',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required,isLength:8:11',
          messages: {
            required: 'swift_bic_required',
            isLength: 'swift_bic_required',
          },
        },
      },
      bankName: {
        name: 'bankName',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required,isLength:2:5000',
          messages: {
            required: 'bank_name_required',
            isLength: 'bank_name_required',
          },
        },
      },
      bankLocation: {
        name: 'bankLocation',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required,isLength:2:5000',
          messages: {
            required: 'bank_location_required',
            isLength: 'bank_location_required',
          },
        },
      },
    },
  },
};

// payment instructions when a car with wire transfer payment is ordered
// also used to enter user's bank data (for example when bank data is needed for car registration)
entityMetaStatic = {
  ...entityMetaStatic,
  'OrderAction:PaymentInstructions': {
    name: 'OrderAction:PaymentInstructions',
    data: {
      ...entityMetaStatic['Financial:BankData'].data,
      reference: {
        name: 'reference',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required,isLength:2:5000',
          messages: {
            required: 'reference_required',
            isLength: 'reference_required',
          },
        },
      },
      paymentInstructions: {
        name: 'paymentInstructions',
        type: 'string',
        acl: { read: true, write: true },
        validate: { rules: '', messages: {} },
      },
    },
  },
};

entityMetaStatic = {
  ...entityMetaStatic,
  'PluginSettings:CommerceAutomotiveCarRental': {
    name: 'PluginSettings:CommerceAutomotiveCarRental',
    data: {
      maxRentDays: {
        name: 'maxRentDays',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required',
          messages: { required: 'This value should not be blank.' },
        },
      },
      maxBookingFuture: {
        name: 'maxBookingFuture',
        type: 'string',
        acl: { read: true, write: true },
        validate: {
          rules: 'required',
          messages: { required: 'This value should not be blank.' },
        },
      },
    },
  },
};

export { entityMetaStatic };

export const entityMetaMapping = {
  client: 'Client:Client',
  clientParent: 'Client:Client',
  user: 'Client:Client',
  note: 'Client:Note',
  message: 'Messaging:Message',
  textMessage: 'Messaging:TextMessage',
  template: 'Mail:Template',
  password: 'Pass:Pass',
  questionnaire: 'Questionnaire:Questionnaire',
  doc: 'Docs:Doc',
  docsList: 'DocsList',
  docType: 'Docs:DocType',
  team: 'Client:Team',
  brand: 'Items:Brand',
  category: 'Items:Category',
  attribute: 'Items:Attribute',
  attributeGroup: 'Items:AttributeGroup',
  item: 'Items:Item',
  itemVariant: 'Items:Variant',
  cmsDescription: 'Translate:EmbeddedCmsDescription',
  clientLocation: 'Client:EmbeddedClientLocation',
  clientLocations: 'LocationList',
  pipeline: 'Leads:Pipeline',
  lead: 'Leads:Lead',
  leadCatcher: 'Leads:LeadCatcher',
  page: 'Cms:Page',
  model: 'Items:Model',
  order: 'Order:Order',
  dataPush: 'DataPush:PushConfig',
  whiteLabel: 'WhiteLabel:WhiteLabelSettings',
  whiteLabelPlugin: 'WhiteLabel:WhiteLabelPlugin',
  checkoutUserData: 'Checkout:UserData',
  checkoutUserDataWithRegistration: 'Checkout:UserDataWithRegistration',
  checkoutCompanyData: 'Checkout:CompanyData',
  checkoutCompanyDataWithRegistration: 'Checkout:CompanyDataWithRegistration',
  cmsLeadForm: 'Cms:LeadForm',
  cmsNewsletterForm: 'Cms:NewsletterForm',
  cmsLoginForm: 'Cms:LoginForm',
  cmsSignupForm: 'Cms:SignupForm',
  cmsContactForm: 'Cms:ContactForm',
  cmsElement: 'Cms:DynamicElement',
  cmsFile: 'Main:S3File',
  checkoutPaymentCashAdditionalInfos: 'Checkout:PaymentCashAdditionalInfos',
  dynamicDataDefinition: 'DynamicData:Definition',
  orderActionPaymentInstructions: 'OrderAction:PaymentInstructions',
  orderActionPickupInvite: 'Order:EmbeddedPickupData',
  socialMediaLoginSecret: 'WhiteLabel:SocialMediaLoginSecret',
  externalAccount: 'Client:ExternalAccount',
  modelGroup: 'Items:ModelGroup',
  modelAsset: 'Items:ModelAsset',
  leadPerMailRule: 'WhiteLabel:LeadPerMailRule',
  pluginSettingsCommerceAutomotiveCarRental: 'PluginSettings:CommerceAutomotiveCarRental',
  chedriCompanySignupForm: 'Chedri:CompanySignupForm',
  financialBankData: 'Financial:BankData',
  priceNegotiation: 'PriceNegotiation:PriceNegotiation',
  address: 'Contact:Address',
  contact: 'Contact:Contact',
};
